import { Injectable } from '@angular/core';
import { Observable,Subject } from 'rxjs';

import * as CryptoJS from 'crypto-js';
import { HttpClient } from '@angular/common/http';
import { restURL } from '../Models/restURL';
import { userService } from './userService';
import { environment } from '../environments/environment';
import { mdlStatus } from '../Models/CompAttachmentsMdl';

 
// @Injectable({
//     providedIn: 'root',
//   })
@Injectable()

export class EncryptionKeyService {

    constructor(private http: HttpClient, private url: restURL, private userInfo: userService) {}

    GetHomeDropDowns(): Promise<void> {
     return new Promise((resolve, reject) => {
       this.GetHomeDDL().subscribe(
         (response) => {
   
           try {          
             
             environment.Master.Code = this.GenerateText(response.DDL.filter(home=>home.TypeCode==2));
             environment.Master.Description = this.GenerateText(response.DDL.filter(home=>home.TypeCode==3));
             environment.St.StatusDesc = this.GenerateText(response.DDL.filter(home=>home.TypeCode==1));          
                
             resolve(); 
           } catch (error) {
             console.error('Error decoding the encryption key:', error);
             reject('Invalid response format');
           }
         },
         (error) => {
           console.error('Error fetching encryption key:', error);
           reject(error); 
         }
       );
     });
   } 
   
   GetHomeDDL() {
     return this.http.get<mdlHomeDDLRes>(this.url.baseURL + "Limra/GetHomeDDL");
   }
 
 
   GenerateText(Guarantors: Guarantor[]): string {
     return Guarantors
       .map((item) => item.TypeDescEn.charAt(item.Code) || "")
       .join(""); 
   }


}

export class mdlHomeDDLRes {
    public st: mdlStatus = new mdlStatus();
    public DDL: Guarantor[] = [];
  }
  
  export class Guarantor{
    // public Type!: string;
    public TypeCode: number;
    public TypeDescEn: string;
    public TypeDescAr: string;
    public Sno: number;
    public Code: number;
  }


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/EncryptionKeyService.ts